import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HomeFundamentalsCardType } from './home-fundamentals-card.enum';
import { CardComponent } from '@components';

@Component({
    selector: 'app-home-fundamentals-card',
    templateUrl: './home-fundamentals-card.component.html',
    styleUrls: ['./home-fundamentals-card.component.scss'],
    imports: [CommonModule, MatCardModule, MatTooltipModule, CardComponent],
    encapsulation: ViewEncapsulation.None,
})
export class HomeFundamentalsCardComponent {
    /** type of card. determines card title */
    @Input() type: HomeFundamentalsCardType;
    /** template for mat-card-content */
    @Input() content: NgTemplateOutlet;
    /** template for mat-card-actions */
    @Input() actions: NgTemplateOutlet;
}
